module.exports = __webpack_public_path__ + "static/media/TMoDGF-Website-Background.de16dd3b.jpg";